/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { Card, Row} from 'reactstrap';
import { symbolPriceFormatter } from '~/helpers/price';
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { FiEye, FiEyeOff  } from "react-icons/fi";
import CardTotalizador from '~/components/CardTotalizador';
import { DivMobile, Container, DivInfo, ButtonMobile } from './styles';


function Totalizador(props) {
	const {isMobile, totalizadorList = [], maxQuantidade = 2} = props;
	const [showValue, setShowValue] = useState(true);
	const [active, setActive] = useState(0);

	function handleChangeActive(direction){
		if(direction === "right"){
			active < maxQuantidade ? setActive(active + 1) : setActive(maxQuantidade)
		}else{
			active > 0 ? setActive(active - 1) : setActive(0)
		}
	}

	return (
		<Container>
		{!isMobile ? (
			<Card
				style={{ borderRadius: '10px 10px 0 0', padding: 18,  margin: 30 }}>
				<Row md={totalizadorList.length > 0 ? totalizadorList.length : maxQuantidade + 1}>
					{totalizadorList.length > 0 && totalizadorList.map((item, index) => (
						<CardTotalizador
							key={index}
							borderColor={item?.borderColor}
							secondValue={item?.secondValue}
							secondText={item?.secondText}
							idTooltip={item?.idTooltip}
							tooltipText={item?.tooltipText}
							textColor={item?.textColor}
							color={item?.color}
							value={item?.value}
							title={item?.title}
							subtitle={item?.subtitle}  />
					))}
				</Row>


			</Card>
		): (
			<DivMobile>
				{totalizadorList.length > 0 && totalizadorList[active].secondText.length > 0
				?
					<>
						<h3>
							{totalizadorList.length > 0 && totalizadorList[active].title}
							<span style={{marginLeft: 72}}>{totalizadorList[active].subtitle}</span>
						</h3>

						<DivInfo>
							<ButtonMobile disabled={active === 0} onClick={() => handleChangeActive("left")}><MdOutlineKeyboardArrowLeft size={50}  /></ButtonMobile>
							<p>{showValue ? totalizadorList.length > 0 &&  symbolPriceFormatter(totalizadorList[active].value): "R$ ---,--"}</p>
							<div style={{marginTop: 12}}>{showValue ? (<FiEye size={30} onClick={() => setShowValue(!showValue)} />) : (<FiEyeOff size={30} onClick={() => setShowValue(!showValue)} />)}</div>
							<ButtonMobile disabled={active === 2} onClick={() => handleChangeActive("right")}><MdOutlineKeyboardArrowRight size={50} /></ButtonMobile>
						</DivInfo>
						<div style={{padding: '0px 70px', display: 'flex', fontSize: '14px', fontWeight: "bold", justifyContent: "space-between", width: '100%'}}>
							<span>{totalizadorList.length > 0 && totalizadorList[active].secondText}</span>
							<span style={{backgroundColor: 'white', padding: '0px 10px'}}>{totalizadorList.length > 0 &&  symbolPriceFormatter(totalizadorList[active].secondValue)}</span>
						</div>
					</>
				:
					<>
						<h3>{totalizadorList.length > 0 &&  totalizadorList[active].title}</h3>

						<DivInfo>
							<ButtonMobile disabled={active === 0} onClick={() => handleChangeActive("left")}><MdOutlineKeyboardArrowLeft size={50}  /></ButtonMobile>
							<p>{showValue ? totalizadorList.length > 0 &&  symbolPriceFormatter(totalizadorList[active].value): "R$ ---,--"}</p>
							<div style={{marginTop: 12}}>{showValue ? (<FiEye size={30} onClick={() => setShowValue(!showValue)} />) : (<FiEyeOff size={30} onClick={() => setShowValue(!showValue)} />)}</div>
							<ButtonMobile disabled={active === maxQuantidade} onClick={() => handleChangeActive("right")}><MdOutlineKeyboardArrowRight size={50} /></ButtonMobile>
						</DivInfo>
						<p style={{fontSize: '12px', padding: 0, margin: 0, fontWeight: "bold", height: "20px"}}>{totalizadorList.length > 0 &&  totalizadorList[active].subtitle}</p>
					</>
				}

			</DivMobile>
			)}
		</Container>
	);
}

export default Totalizador;
